export default __webpack_public_path__ + "static/media/profile.eeba6bb0.svg";